export default __webpack_public_path__ + "static/media/email.900910c6.svg";